/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import { SkinnyCustomerFragmentFragmentDoc } from '../../../models/generated/SkinnyCustomerFragment';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SessionCustomerQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SessionCustomerQuery = { me: { customer: { id: number, name: string, code_name: string, isClusterViolated: boolean, recipientsCount: number, timezone: string, canSendSMS: boolean, clusterSize: number, freemiumCreatorEmail?: string | undefined, paidPackages?: Array<string> | undefined, language: { code: string, localizedLabel: string, translatedLabel: string }, packages: Array<{ id: number, description: string, icon: string, label: string, isEnabled: boolean, codeName: Types.PackageCode }>, leds: Array<{ type: Types.CustomerLedType, phoneContact: { phones?: Array<{ phone: string }> | undefined } }>, customerContacts?: Array<{ nanoId: string, email: string, identity: string, imageUrl: string }> | undefined, psyCompany?: { psyDispositifs: Array<{ name: string, nanoId: string }> } | undefined } } };


export const SessionCustomerDocument = gql`
    query SessionCustomer {
  me {
    customer {
      ...SkinnyCustomerFragment
    }
  }
}
    ${SkinnyCustomerFragmentFragmentDoc}`;

/**
 * __useSessionCustomerQuery__
 *
 * To run a query within a React component, call `useSessionCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useSessionCustomerQuery(baseOptions?: Apollo.QueryHookOptions<SessionCustomerQuery, SessionCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionCustomerQuery, SessionCustomerQueryVariables>(SessionCustomerDocument, options);
      }
export function useSessionCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionCustomerQuery, SessionCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionCustomerQuery, SessionCustomerQueryVariables>(SessionCustomerDocument, options);
        }
export type SessionCustomerQueryHookResult = ReturnType<typeof useSessionCustomerQuery>;
export type SessionCustomerLazyQueryHookResult = ReturnType<typeof useSessionCustomerLazyQuery>;
export type SessionCustomerQueryResult = Apollo.QueryResult<SessionCustomerQuery, SessionCustomerQueryVariables>;